import Immutable from 'immutable'
import moment from 'moment'

export const AccountingRecord = Immutable.Record({
  anniversary: null,
  contractEnd: null,
  contractLength: null,
  contractStart: null,
  dateLastInvoiced: null,
  dateNextInvoice: null,
  interval: null,
  intervalPrice: 0.0,
  invoiceDateAdjustment: null,
  nextPeriod: null,
  overdueBehaviour: null,
  planGroup: null,
  planId: null,
}, 'ServiceAccounting')

export default function createServiceAccounting({
  anniversary,
  contract_end,
  contract_length,
  contract_start,
  date_last_invoiced,
  date_next_invoice,
  interval,
  invoice_date_adjustment,
  next_period,
  overdue_behaviour,
  plan_group,
  plan_id,
  ...data
} = {}) {
  /* eslint-disable camelcase */
  return new AccountingRecord({
    anniversary: anniversary ? moment(anniversary) : null,
    contractEnd: contract_end ? moment(contract_end) : null,
    contractLength: contract_length ? moment.duration(contract_length) : null,
    contractStart: contract_start ? moment(contract_start) : null,
    dateLastInvoiced: date_last_invoiced ? moment(date_last_invoiced) : null,
    dateNextInvoice: date_next_invoice ? moment(date_next_invoice) : null,
    interval: interval ? moment.duration(interval) : null,
    invoiceDateAdjustment: invoice_date_adjustment ? moment.duration(invoice_date_adjustment) : null,
    nextPeriod: next_period ? moment(next_period) : null,
    overdueBehaviour: overdue_behaviour,
    planGroup: plan_group,
    planId: plan_id,
    ...data,
  })
  /* eslint-enable camelcase */
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/Service/Accounting.js